module.exports = __webpack_public_path__ + "1c2ca30a4c268749a3f9255420100115.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/FJ.svg
// module id = mbqa
// module chunks = 0